import { usePermissions } from '../../iam/permissions-context.js';

export function useCanViewCost(): boolean {
  const { permissions, loading } = usePermissions();
  return !loading && permissions.includes('inventory:showpartcost');
}
